// .core
import React from 'react'
// config
import css from './Link.module.scss'

export const Link = (props: React.HTMLProps<HTMLAnchorElement>) => {
  return <a {...props} className={`${css.anchor} ${props.className}`} />
}
